import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
/**
 * @description
 * Administrator for rocket API
 */
var state = {
    permission: {
        optimal: true,
        cookieAccept: false
        // read: "https://www.googleapis.com/auth/youtube.readonly",
        // write: "https://www.googleapis.com/auth/youtube.force-ssl"
    },
    system: {
        getEmailAddress: function () { return 'greespiral@gmail.com'; },
        hardCodeAccount: {
            getEmailAddress: function () { return 'zlatnaspirala@gmail.com'; },
            adminAccountToken: function () { return '9607qk05p3k0uncp3oe9fczdldlfzlg6mhtllchugueg'; }
        }
    },
    appStyle: {
        themes: function () { return [
            'Dark', 'Orange', 'Light', 'Blue', 'Red', 'Pink', 'Purple', 'Deeppurple',
            'Indigo', 'Lightblue', 'Teal', 'Green', 'Lightgreen', 'Lime', 'Yellow',
            'Cyan', 'Deeporange', 'Brown', 'Black'
        ]; }
    }
};
var mutations = {
    cookieAccept: function (state, _a) {
        var yesOrNo = _a.yesOrNo;
        state.permission.cookieAccept = yesOrNo;
        console.log("Application instance store call cookieAccept method.", yesOrNo);
    }
};
export default new Vuex.Store({
    state: state,
    mutations: mutations
});
